import { createContext, SetStateAction } from "react";

export type WidgetTaskCollectionTask = {
  id: string;
  title: string;
  sectionId: string;
  sectionTitle: string;
  ordinal: number;
  routineTitle: string;
};

export const WidgetTaskCollectionContext = createContext<{
  setSelectedTasks(_: SetStateAction<WidgetTaskCollectionTask[]>): void;
  selectedTasks: WidgetTaskCollectionTask[];
  setTitle(_: SetStateAction<string>): void;
  title: string;
}>({
  setSelectedTasks: () => {},
  selectedTasks: [],
  title: "",
  setTitle: () => {},
});
